export default __webpack_public_path__ + "static/media/account-btn-bg.15d0503f.png";